export default {
  name: 'bp-null',
  template: '<div></div>'
}
